import React, { Dispatch, SetStateAction, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import './menu.css'
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BorderMenuPage, emptyMenuPage, MenuContentPage, typeDailyMenu } from "../types/types";
import { PageMenu } from "../pageMenu/pageMenu";
import RightBar from "./RightBarRestau/RightBarRestau";
import { LiaHandPointerSolid } from "react-icons/lia";
import { MdFullscreen } from "react-icons/md";
import { TfiClose } from "react-icons/tfi";
import MaskBackground from "../maskBackground/maskBackground";
interface MenuProps {
    styleMenu:number,
    dobbleMenu: [MenuContentPage,MenuContentPage][],
    fullScreen:boolean,
    setFullScreen:Dispatch<SetStateAction<boolean>>,
    dateUpdate:Date,
    interactmenu:boolean,
    setFullPlat?:Dispatch<SetStateAction<string>>,
    startPage?:[number,number],
    currentDaily?:boolean,
    dailyMenu?:typeDailyMenu,
    setShowDailyMenu?:Dispatch<SetStateAction<boolean>>,

}

export function useIsPinchZoomed(isMobile: boolean) {
  const isZoomedRef = useRef(false); 

  useEffect(() => {
    if (!isMobile) return;
    let raf = 0;

    const update = () => {
      raf = 0;
      const scale = vv?.scale ?? 1;
      isZoomedRef.current = scale > 1.01;
    };


    const onChange = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const vv = (window as any).visualViewport;
    if (vv) {
      vv.addEventListener("resize", onChange, { passive: true });
      vv.addEventListener("scroll", onChange, { passive: true });
      update();
      return () => {
        vv.removeEventListener("resize", onChange);
        vv.removeEventListener("scroll", onChange);
        if (raf) cancelAnimationFrame(raf);
      };
    }

    const onWindowChange = () => {
      const ratio = document.documentElement.clientWidth / window.innerWidth;
      isZoomedRef.current = ratio < 0.98;
    };
    window.addEventListener("resize", onWindowChange, { passive: true });
    window.addEventListener("orientationchange", onWindowChange);
    onWindowChange();
    return () => {
      window.removeEventListener("resize", onWindowChange);
      window.removeEventListener("orientationchange", onWindowChange);
    };
  }, [isMobile]);

  return { isZoomedRef };
}
function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function checkMobile() {
        setIsMobile(window.matchMedia('(max-width: 1050px)').matches);
        }
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return isMobile;
}

const MenuRestau:React.FC<MenuProps> = ({styleMenu,dobbleMenu,dateUpdate,interactmenu,setFullPlat,fullScreen,setFullScreen,startPage,currentDaily=false,dailyMenu,setShowDailyMenu}) => {
    const [pageShow, setPageShow] = useState([0,1])
    const [maxIndex,setMaxIndex] = useState(dobbleMenu.length*2)
    const [borderPages,setBorderPages] = useState<BorderMenuPage | null>(null)

    const [borderStyleVars, setBorderStyleVars] = useState<React.CSSProperties>({});
    
    const zCounterRef = useRef(1);
    useEffect(() => {
        zCounterRef.current = dobbleMenu.length * 2;
    }, [dobbleMenu.length]);
    const Z_MAX = 200; 

    const renormalizeZ = () => {
        const nodes = document.querySelectorAll<HTMLElement>(".menuRestauTel .pageRestauTel");
        let z = 1;
        nodes.forEach((n) => {
            n.style.zIndex = String(z++);
        });
        zCounterRef.current = z;
    };
    const canUseContentVisibility = typeof CSS !== "undefined" && CSS.supports?.("content-visibility", "auto");
    const bringToFront = (el: HTMLElement) => {
        el.style.zIndex = String(zCounterRef.current++);
        if (zCounterRef.current > Z_MAX) renormalizeZ();
    };
    const nudgeScroll = () => {
        requestAnimationFrame(() => {
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            window.scrollTo(0, y + 10);
            requestAnimationFrame(() => window.scrollTo(0, y));
        });
    };
    const isMobile = useIsMobile();
    const lengthMenuPhone = React.useMemo(() => {
        if (!dobbleMenu || !dobbleMenu.length) return 0;
        if (dobbleMenu.length < 2) return 1;

        const last = dobbleMenu[dobbleMenu.length - 1];
        const backEmpty = last[1].elements.length === 0;
        const frontEmpty = last[0].elements.length === 0;

        const penalty = backEmpty ? (frontEmpty ? 3 : 2) : 1;
        return dobbleMenu.length * 2 - penalty;
    }, [dobbleMenu]);
    useEffect(() => { 
        if(dobbleMenu && dobbleMenu.length > 1 && 'borderpage' in dobbleMenu[0][1] && dobbleMenu[0][1].borderpage) {
            setBorderPages(dobbleMenu[0][1].borderpage as BorderMenuPage| null)
            const {color, colorline} = dobbleMenu[0][1].borderpage
            setBorderStyleVars(() => {
                const vars: React.CSSProperties = {};

                if (color) {
                (vars as any)['--qr-border-bg-strong'] = color;
                (vars as any)['--qr-border-bg-soft'] = color;
                }

                if (colorline) {
                (vars as any)['--qr-border-line'] = colorline;
                }

                return vars;
            });
        }

      
    },[dobbleMenu]) 
    useEffect(() => {
        setPageShow([0,1])
        setMaxIndex(dobbleMenu.length)
        if(startPage){
            let testStart= [0,1]
            while(testStart[0] !== startPage[0] && testStart[1] !== startPage[1]) {
                const movePage = document.getElementById(`pageRestau${testStart[1]}`)
                const nextMovePage = document.getElementById(`pageRestau${testStart[1]+1}`)   
                if(movePage) {
                    requestAnimationFrame(() => {
                        movePage.classList.add("flipped")
                        bringToFront(movePage)
                    })
                }
                setPageShow([testStart[0]+1,testStart[1]+1])
                testStart = [testStart[0]+1,testStart[1]+1]
                if(nextMovePage) {
                    setTimeout(() => {
                        bringToFront(nextMovePage)
                    }, 100);     
                }
            }
        }
      }, []);
    const [isTurning, setIsTurning] = useState(false);
    const clickRightPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[1]}`)
        const nextMovePage = document.getElementById(`pageRestau${pageShow[1]+1}`)   
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                bringToFront(movePage)
            })
        }
        setPageShow([pageShow[0]+1,pageShow[1]+1])
        if(nextMovePage) {
            setTimeout(() => {
                bringToFront(nextMovePage)
            }, 300);     
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickLeftPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[0]}`)    
        if(pageShow[0]-1 === -1) setPageShow([0,1])
        else setPageShow([pageShow[0]-1,pageShow[1]-1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                bringToFront(movePage)
            })
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickRightPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel' 
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '0' : '1') +  pageShow[1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                bringToFront(movePage)
                
            })
        }
        setPageShow(prev => {
            const [a, b] = prev;
            return (a === b) ? [a, b + 1] : [b, b];
        });
    
        setTimeout(() => setIsTurning(false), 300);
    }
    const clickLeftPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel'
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '1' : '0') +  pageShow[0]) 
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                bringToFront(movePage)
            })
        }
        setPageShow(prev => {
    const [a, b] = prev;
    if (a - 1 < 0) return [0, 1];

    if (a === b) return [a - 1, b];
    return [a, a];
  });
        setTimeout(() => setIsTurning(false), 300);
    }

    const touchStartX= useRef(0);
    const touchStartY = useRef(0);
    const isHorizontalSwipe = useRef(false);
    const {  isZoomedRef } = useIsPinchZoomed(isMobile);
    const isSwipeBlocked = useRef(false);
    const pinchDetected = useRef(false);
    const handleTouchStart = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        pinchDetected.current = false;
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        isSwipeBlocked.current = !!isMobile && isZoomedRef.current;
        if (isSwipeBlocked.current) {
            return;
        }
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
        isHorizontalSwipe.current = false;
    }, [isMobile, isZoomedRef]);
    const handleTouchMovePageMenu = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        if (isSwipeBlocked.current || pinchDetected.current) return;
        const deltaX = e.touches[0].clientX - touchStartX.current;
        const deltaY = e.touches[0].clientY - touchStartY.current;

        if (Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
            isHorizontalSwipe.current = true;
            if (e.cancelable) e.preventDefault();
        }
    },[]);
    const handleTouchEnd = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (isSwipeBlocked.current) {
            isSwipeBlocked.current = false;
            return;
        }
        if (!isHorizontalSwipe.current || e.changedTouches.length > 1 || pinchDetected.current) {
            pinchDetected.current = false;
            return;
        }
        const touchEndX = e.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX.current;
        if (distance < -50) {
            if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone) {
                clickRightPageTel();
            }
        } else if(distance > 50) {
            if(pageShow[0] > 0) clickLeftPageTel()
        }
        
    },[pageShow, lengthMenuPhone, clickRightPageTel, clickLeftPageTel]);

    const handleFullScreen = () => {
        if(window.matchMedia('(max-width: 1050px)').matches) {
            setFullScreen(!fullScreen);
            if(!fullScreen)nudgeScroll()
            setPageShow([0,1])
        }
    }

    const listRef = useRef<HTMLDivElement | null>(null);
    const [scaleReady, setScaleReady] = useState(false);
    
    const scalesRef = useRef<Map<HTMLElement, number>>(new Map());
    const lastScrollLeftRef = useRef(0);
    const lastTRef = useRef(0);

    const scrollToFirstCardCenter = useCallback(() => {
        const scroller = listRef.current;
        if (!scroller) return false;
        const cards = Array.from(scroller.querySelectorAll<HTMLElement>(".containerCoverMenu"));
        if (!cards.length) return false;

        const firstCard = currentDaily ? cards[0] : cards[0];
        const target = firstCard.offsetLeft - (scroller.clientWidth - firstCard.offsetWidth) / 2;

        if (Math.abs(scroller.scrollLeft - target) <= 2) return true;

        scroller.classList.add("snapOff");
        scroller.scrollTo({ left: target, top: 0, behavior: "auto" });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            scroller.scrollTo({ left: target, top: 0, behavior: "auto" });
            scroller.classList.remove("snapOff");
            });
        });

        return true;
    }, [currentDaily]);
    const timeoutsRef = useRef<number[]>([]);

    const clearCenteringTimeouts = () => {
        timeoutsRef.current.forEach((id) => clearTimeout(id));
        timeoutsRef.current = [];
    };

    const runStableCentering = useCallback(() => {
        const scroller = listRef.current;
        if (!scroller) return;

        clearCenteringTimeouts();

        let tries = 0;
        let last = scroller.scrollLeft;

        const step = () => {
            tries++;

            const done = scrollToFirstCardCenter(); 
            const now = scroller.scrollLeft;
            if (done && Math.abs(now - last) <= 1) return;
            if (tries >= 8) return; 

            last = now;
            requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 80));
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 240));
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 700));
    }, [scrollToFirstCardCenter]);

    useLayoutEffect(() => {
        if (!isMobile || fullScreen) return;
        if (!listRef.current) return;

        runStableCentering();

        const onPageShow = (e: PageTransitionEvent) => {
            runStableCentering();
        };

        const vv = (window as any).visualViewport as VisualViewport | undefined;
        const onVV = () => runStableCentering();

        window.addEventListener("pageshow", onPageShow);
        window.addEventListener("resize", onVV, { passive: true });
        window.addEventListener("orientationchange", onVV);

        if (vv) {
            vv.addEventListener("resize", onVV, { passive: true });
            vv.addEventListener("scroll", onVV, { passive: true });
        }
        const scroller = listRef.current!;
        const imgs = Array.from(scroller.querySelectorAll("img"));
        const onImgLoad = () => runStableCentering();
        imgs.forEach((img) => {
            if (!img.complete) img.addEventListener("load", onImgLoad, { once: true });
        });

        return () => {
            clearCenteringTimeouts()
            window.removeEventListener("pageshow", onPageShow);
            window.removeEventListener("resize", onVV);
            window.removeEventListener("orientationchange", onVV);
            if (vv) {
            vv.removeEventListener("resize", onVV);
            vv.removeEventListener("scroll", onVV);
            }
        };
        }, [isMobile,fullScreen,currentDaily,dobbleMenu?.length,dailyMenu?.image,runStableCentering,
    ]);

    useLayoutEffect(() => {
        if (fullScreen || !isMobile) return;

        const scroller = listRef.current;
        if (!scroller) return;

        const items = Array.from(scroller.querySelectorAll<HTMLElement>(".containerCoverMenu"));

        if (items.length <= 1) {
            items.forEach((el) => el.style.setProperty("--qr-scale", "1"));
            setScaleReady(true);
            return;
        }
        scalesRef.current.clear();
        for (const el of items) scalesRef.current.set(el, 1);

        let raf = 0;

        const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));
        const round4 = (v: number) => Math.round(v * 10000) / 10000;

        const update = (now: number) => {
            raf = 0;

            const rW = scroller.clientWidth;
            const centerX = scroller.scrollLeft + rW / 2;

            const sl = scroller.scrollLeft;
            const prevSl = lastScrollLeftRef.current;
            const prevT = lastTRef.current;

            const dt = Math.max(16, (prevT ? now - prevT : 16));
            const velocity = Math.abs(sl - prevSl) / dt; 

            lastScrollLeftRef.current = sl;
            lastTRef.current = now;

            const range = rW * 0.55;
            const lerpFactor = velocity > 1.2 ? 0.22 : 0.35;

            const threshold = velocity > 1.2 ? 0.0035 : 0.0025;

            for (const el of items) {
                const itemCenter = el.offsetLeft + el.offsetWidth / 2;
                const dist = Math.abs(itemCenter - centerX);
                const t = clamp(dist / range, 0, 1);
                const target = 1 - t * 0.1;

                const current = scalesRef.current.get(el) ?? 1;
                const next = current + (target - current) * lerpFactor;
                const rounded = round4(next);
                if (Math.abs(rounded - current) > threshold) {
                    el.style.setProperty("--qr-scale", String(rounded));
                    scalesRef.current.set(el, rounded);
                }
            }
        };

        const schedule = () => {
            if (!raf) raf = requestAnimationFrame((t) => update(t));
        };
        scroller.addEventListener("scroll", schedule, { passive: true });
        window.addEventListener("resize", schedule, { passive: true });
        requestAnimationFrame((t) => {
            update(t);
            requestAnimationFrame((t2) => {
            update(t2);
            setScaleReady(true);
            });
        });

        return () => {
            scroller.removeEventListener("scroll", schedule);
            window.removeEventListener("resize", schedule);
            if (raf) cancelAnimationFrame(raf);
        };
    }, [fullScreen, isMobile, currentDaily, dailyMenu?.image, dobbleMenu?.length]);

    return (
        <>{fullScreen && <div className="maskFullScreenRestauTel"> <MaskBackground /> </div>}
        <div className={`containerMenuBase secondaryBack ${fullScreen ? 'isFullScreen' : ''}`} >
            
            <div className="mainCorp " >
                {pageShow[0] === 0 ?
                    <div className="borderMenuRestau" style={{marginRight:'1%'}}></div>
                    :
                    <div className="borderMenuRestau lowOpacityHover" style={{marginRight:'1%'}}>
                        <div onClick={clickLeftPage} className="pointer ">
                            <FiChevronLeft size={30}  /> 
                        </div>
                    </div>
                }               
                
                {!isMobile && <div className='menuRestau' style={borderStyleVars}>
                    <div className={`pagesEffectLeft style${styleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                    <div className={`pagesEffectRight style${styleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                    {
                     dobbleMenu.map((elem,idMenu) => {
                        return (
                            idMenu === 0 ? 
                                <div className={`pageRestau flipped`} id='page0' key={`pageResto0`} >
                                    <PageMenu key={"pageRestoFF0"+idMenu} pageShow={pageShow[1]} content={emptyMenuPage} index={idMenu} front={true} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={true}/>
                                    <PageMenu key={"pageRestoFB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={false}/>
                                </div>     
                            : 
                            <div className='pageRestau smallText' key={`pageResto0${idMenu}`} id={`pageRestau${idMenu}`} style={{zIndex: maxIndex - idMenu}}>
                                <PageMenu key={"pageRestoF0"+idMenu} pageShow={pageShow[1]} content={elem[0]} index={idMenu} front={true} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={true}/>
                                <PageMenu key={"pageRestoB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={styleMenu} isInteract={interactmenu} frontTel={false}/>
                            </div> )
                     })
                    }
                    <div className="bottomInfo">
                        <i className="dateUpdate XsmallText">Dernière mise à jour le : {(new Date(dateUpdate || '')).toLocaleDateString()}</i>
                    </div>
                </div> }

                {isMobile && fullScreen && (
                <div
                    className="closeOverlay"
                    onClick={() => setFullScreen(false)}
                />
                )}
               {isMobile && <div className={`menuRestauTel ${fullScreen ? 'isFullScreen' : 'notFullScreen'}`} onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMovePageMenu}
                    onTouchEnd={handleTouchEnd}>
                    {!fullScreen ? 
                        <div className={`listMenu ${scaleReady ? "scaleReady" : ""}`}  ref={listRef}>
                            {currentDaily && <div className="spacer-start" aria-hidden="true" />}
                            {currentDaily && <div className="containerCoverMenu isForDailyMenu" >
                                <div className="coverMenu" onClick={() => {if(setShowDailyMenu){setShowDailyMenu(true)}}} >   
                                    <div className="contentCover"> 
                                        <img
                                            src={dailyMenu?.image || ''}
                                            className="dailyMenu"
                                            loading="lazy"
                                            alt="menu du jour"
                                            style={{display: 'flex'}}
                                        />
                                    </div>
                                    <div className="maskCover"></div>
                                    <div className="fullScreenButton smallTextBold primaryBack">
                                        <MdFullscreen className="icon" size={18}/>
                                        <span>Afficher</span>
                                    </div>
                                </div>
                                <div className="footerPartCover">
                                    <span className="largeTitle">Menu du jour</span>
                                    <i className="dateUpdate XsmallText">Menu du :&nbsp; {dailyMenu ? <>{dailyMenu.dates.length === 1 ? (<i>
                                        {new Intl.DateTimeFormat("fr-FR", {
                                            weekday: "long",
                                            day: "numeric",
                                            month: "long"
                                        })
                                        .format(new Date(dailyMenu.dates[0]))
                                        .replace(/^./, (str) => str.toUpperCase())}
                                     </i>   
                                    ) : (
                                        <> {new Date(dailyMenu.dates[0]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}
                                            <i style={{ marginRight: '5px', marginLeft: '5px' }}>au</i>
                                            {new Date(dailyMenu.dates[1]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}
                                        </>
                                    )}</> : '/' }</i>
                                </div>
                            </div>}
                            <div className="containerCoverMenu" >
                                <div className="coverMenu" onClick={handleFullScreen}  style={borderStyleVars} >   
                                    <div className="contentCover"> 
                                        <div className={`pageRestauTel smallText flipped`}  >
                                            <PageMenu   pageShow={0} content={dobbleMenu[0][1]} index={0} front={false} frontTel={false} StyleMenu={styleMenu}  isInteract={interactmenu} isPhone={true}  />
                                        </div>
                                    </div>
                                    <div className={`pagesEffectRight style${styleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                                    
                                    <div className="maskCover"></div>
                                    <div className="fullScreenButton smallTextBold primaryBack">
                                        <MdFullscreen className="icon" size={18}/>
                                        <span>Afficher</span>
                                    </div>
                                </div>
                                <div className="footerPartCover">
                                    <span className="largeTitle">La Carte</span>
                                    <i className="dateUpdate XsmallText">Mise à jour le {(new Date(dateUpdate || '')).toLocaleDateString()}</i>
                                </div>
                            </div>
                            {currentDaily && <div className="spacer-end" aria-hidden="true" />}
                        </div>
                                :
                                <>{
                     dobbleMenu.map((elem,idMenu) => {
                        if(pageShow[1] + 1 < idMenu) return null;
                        const dist = Math.abs(pageShow[0] - idMenu);
                        const isNear = dist <= 2;
                        const perfStyle = canUseContentVisibility && !isNear ? ({ contentVisibility: "auto", containIntrinsicSize: "432px 612px" }as const): undefined;           
                        const willChangeStyle = isNear ? ({ willChange: "transform" } as const) : undefined;
                        return ( 
                                <React.Fragment key={`pageRestotel01${idMenu}`}>
                                    
                                    <div className={`pageRestauTel smallText  ${idMenu === 0 ? 'flipped' : ''}`}  id={`pageRestauTel0${idMenu}`} style={{...perfStyle,...willChangeStyle}} >
                                        <PageMenu key={"pageRestoB1"+idMenu+Number(fullScreen)}  pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} frontTel={false} StyleMenu={styleMenu}  isInteract={interactmenu} isPhone={true}  />                                 
                                    </div>
                                    {idMenu !== 0 && 
                                    <div className={`pageRestauTel smallText `}   id={`pageRestauTel1${idMenu}`} style={{...perfStyle,...willChangeStyle}} >
                                        <PageMenu key={"pageRestoF0"+idMenu+Number(fullScreen)} pageShow={pageShow[1]} content={elem[0]} index={idMenu} front={false} frontTel={true} StyleMenu={styleMenu}  isInteract={interactmenu} isPhone={true} />
                                    </div> }
                    
                                </React.Fragment>
                            )
                        })}
                        <div className={`iconFullScren `} onClick={handleFullScreen}><div><TfiClose className="icon" size={12}/></div></div>
                        </>
                    }
                    
                    {fullScreen && <div className="bottomInfo">
                        
                        <div className="numberPagesPhone smallText">
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) <= 1 ? 'lock' : ''}`} onClick={() => {if(pageShow[0] > 0) {clickLeftPageTel()}}}><FiChevronLeft className="buttonTurn" size={18}/></div>
                            <span>{pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)}/{lengthMenuPhone}</span>
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) >= lengthMenuPhone ? 'lock' : ''}`} onClick={() => {if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone){clickRightPageTel()}}}><FiChevronRight className="buttonTurn" size={18} /></div>
                        </div>
                    </div>}
                </div> }


                <div className="borderMenuRestau pointer lowOpacityHover" style={{marginLeft:'1%'}}> {  pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )&& 
                    <div onClick={clickRightPage }  className="pointer">
                        <FiChevronRight size={30}   /> 
                    </div>
                    } 
                </div>
                {interactmenu && <RightBar isFullScreen={fullScreen} dobbleMenu={dobbleMenu} setFullPlat={setFullPlat}/>}
            </div>   
        </div>
        </>
    )
}

export default MenuRestau


